import styles from './radioButton.scss';
import cn from 'classnames';
import { FocusEventHandler } from 'react';
import { AppearanceTypes } from '../Layout/base';

export interface RadioButtonProps {
  checked: boolean;
  label?: string | JSX.Element;
  onChange?: (value: string | number) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  className?: string;
  radioButtonClassName?: string;
  value: string | number;
  disabled?: boolean;
  appearance?: AppearanceTypes;
  size?: 'large' | 'small';
  name?: string;
  uniqueName?: string;
}

export const RadioButton = ({
  label,
  className,
  radioButtonClassName,
  appearance = 'primary',
  size = 'large',
  onChange,
  value,
  disabled,
  checked,
  name
}: RadioButtonProps) => {
  const handleChange = () => {
    !disabled && onChange && onChange(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === ' ') {
      handleChange();
    }
  };

  return (
    <label className={cn(styles.wrapper, { [styles.disabled]: disabled }, className)}>
      <div
        onKeyDown={handleKeyDown}
        tabIndex={0}
        className={cn(styles.radioButton, radioButtonClassName, {
          [styles.selected]: checked,
          [styles.disabled]: disabled,
          [styles.primary]: appearance === 'primary',
          [styles.secondary]: appearance === 'secondary',
          [styles.large]: size === 'large',
          [styles.small]: size === 'small'
        })}
      >
        <input
          tabIndex={-1}
          type="radio"
          name={name}
          onChange={handleChange}
          value={value}
          checked={checked}
        />
      </div>
      {label}
    </label>
  );
};
